import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import SvgIcon from '@material-ui/core/SvgIcon'
import PropTypes from 'prop-types'

const styles = theme => ({})

// First try to find in the material-ui core icons here: https://material.io/tools/icons/?style=baseline
// Second try to get it from here which are compatable with code below: https://materialdesignicons.com/
// If you can't find it at materialdesignicons.com, try to convert it.
//  Resize to 24x24: https://www.iloveimg.com/resize-image/resize-svg (inkscape didn't work)
//  Optimise path here: http://petercollingridge.appspot.com/svg-optimiser
function IconReport (props) {
  const { classes, htmlColor, iconSizeEnum } = props
  return (
    <div className={classes.root}>
      <SvgIcon className={classes.icon} htmlColor={htmlColor} fontSize={iconSizeEnum}>
        <path d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z" />
      </SvgIcon>
    </div>
  )
}

IconReport.propTypes = {
  classes: PropTypes.object.isRequired,
  htmlColor: PropTypes.string,
  iconSizeEnum: PropTypes.string
}

export default withStyles(styles)(IconReport)
